import { SectionHeader } from "@/components/Reveal";
import { fuhrpark } from "@/data/content";

const Card = ({ v }) => (
  <div className="group relative mx-3 w-[300px] shrink-0 md:w-[380px]" data-testid={`fuhrpark-card-${v.name}`}>
    <div className="overflow-hidden border-2 border-fw-gold/50 bg-white p-2">
      <img
        src={v.image}
        alt={v.name}
        className="h-56 w-full object-cover transition-transform duration-700 group-hover:scale-105 md:h-64"
      />
    </div>
    <div className="mt-3 flex items-baseline justify-between">
      <h3 className="font-technical uppercase font-bold text-xl text-fw-navy">{v.name}</h3>
      <span className="font-body text-sm text-fw-red">{v.jahre}</span>
    </div>
  </div>
);

const Fuhrpark = () => {
  const loop = [...fuhrpark.vehicles, ...fuhrpark.vehicles];
  return (
    <section id="fuhrpark" className="grain relative bg-fw-paper py-24 md:py-32 overflow-hidden" data-testid="fuhrpark-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <SectionHeader kicker="Fuhrpark" title={fuhrpark.title} subtitle={fuhrpark.subtitle} testId="fuhrpark-header" />
      </div>
      <div className="relative w-full overflow-hidden">
        <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
          {loop.map((v, i) => (
            <Card key={i} v={v} />
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-fw-paper to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-fw-paper to-transparent" />
      </div>
    </section>
  );
};

export default Fuhrpark;
